import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { PreferenceValue } from '@/contexts/preferences/Preferences.interfaces'

export const usePreferencesStore = defineStore('preferences', () => {
  const preferences = ref<Record<string, PreferenceValue | null>>({})

  const getPreference = (preferenceKey: string): PreferenceValue | null => {
    return preferences.value[preferenceKey] ?? null
  }

  const setPreference = (preferenceKey: string, value: PreferenceValue | null): void => {
    preferences.value = { ...preferences.value, [preferenceKey]: value }
  }

  return { preferences, getPreference, setPreference }
})
